// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__container--Y2Rio {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.style__header--yah0s {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.style__searchBox--zNYj8 {
  flex-grow: 1;
  max-width: 32rem;
  padding-top: 0.5rem;
}
.style__modulesContainer--fNyvF {
  overflow: auto;
  padding-top: 0.5rem;
}
.style__moduleTable--IbN5v {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid var(--sys-color-outline-variant);
  border-radius: 8px;
  overflow: hidden;
  font-size: 0.875rem;
  table-layout: fixed;
}
.style__moduleTable--IbN5v th, .style__moduleTable--IbN5v td {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid var(--sys-color-outline-variant);
}
.style__moduleTable--IbN5v th {
  font-weight: 600;
  color: var(--sys-color-on-surface-variant);
  border-bottom: 2px solid var(--sys-color-outline-variant);
}
.style__moduleTable--IbN5v td {
  vertical-align: middle;
}
.style__moduleTable--IbN5v tr:last-child td {
  border-bottom: none;
}
.style__moduleTable--IbN5v tr:hover td {
  background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));
}
.style__thName--DVqWh, .style__tdName--AGnOB {
  width: auto;
}
.style__thSim--UiopJ, .style__tdSim--IedDf {
  width: 10rem;
}
.style__thWhitelisted--ltCBT, .style__tdWhitelisted--XC7TU {
  width: 7rem;
  text-align: center;
}
.style__emptyState--H_ZvJ {
  padding: 2rem 0;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CustomModulePartnersPage/style.less"],"names":[],"mappings":"AAEA;EAEI,aAAA;EACA,sBAAA;EACA,SAAA;AAFJ;AAFA;EAQI,aAAA;EACA,mBAAA;EACA,8BAAA;AAHJ;AAPA;EAcI,YAAA;EACA,gBAAA;EACA,mBAAA;AAJJ;AAZA;EAoBI,cAAA;EACA,mBAAA;AALJ;AAhBA;EAyBI,WAAA;EACA,yBAAA;EACA,kDAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AANJ;AAzBA;EAkCM,qBAAA;EACA,gBAAA;EACA,yDAAA;AALN;AA/BA;EAwCM,gBAAA;EACA,0CAAA;EACA,yDAAA;AANN;AApCA;EA8CM,sBAAA;AAPN;AAvCA;EAkDM,mBAAA;AARN;AA1CA;EAsDM,iEAAA;AATN;AA7CA;EA2DI,WAAA;AAVJ;AAjDA;EA+DI,YAAA;AAVJ;AArDA;EAmEI,WAAA;EACA,kBAAA;AAVJ;AA1DA;EAwEI,eAAA;EACA,kBAAA;AAXJ","sourcesContent":["@import '@yaak/components/src/spacing';\n\n:local {\n  .container {\n    display: flex;\n    flex-direction: column;\n    gap: @spacing-100;\n  }\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .searchBox {\n    flex-grow: 1;\n    max-width: 32rem;\n    padding-top: @spacing-50;\n  }\n\n  .modulesContainer {\n    overflow: auto;\n    padding-top: @spacing-50;\n  }\n\n  .moduleTable {\n    width: 100%;\n    border-collapse: collapse;\n    border: 1px solid var(--sys-color-outline-variant);\n    border-radius: 8px;\n    overflow: hidden;\n    font-size: 0.875rem;\n    table-layout: fixed;\n\n    th, td {\n      padding: @spacing-75 @spacing-100;\n      text-align: left;\n      border-bottom: 1px solid var(--sys-color-outline-variant);\n    }\n\n    th {\n      font-weight: 600;\n      color: var(--sys-color-on-surface-variant);\n      border-bottom: 2px solid var(--sys-color-outline-variant);\n    }\n\n    td {\n      vertical-align: middle;\n    }\n\n    tr:last-child td {\n      border-bottom: none;\n    }\n\n    tr:hover td {\n      background: var(--sys-color-surface-variant, rgba(0, 0, 0, 0.04));\n    }\n  }\n\n  .thName, .tdName {\n    width: auto;\n  }\n\n  .thSim, .tdSim {\n    width: 10rem;\n  }\n\n  .thWhitelisted, .tdWhitelisted {\n    width: 7rem;\n    text-align: center;\n  }\n\n  .emptyState {\n    padding: @spacing-200 0;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `style__container--Y2Rio`,
	"header": `style__header--yah0s`,
	"searchBox": `style__searchBox--zNYj8`,
	"modulesContainer": `style__modulesContainer--fNyvF`,
	"moduleTable": `style__moduleTable--IbN5v`,
	"thName": `style__thName--DVqWh`,
	"tdName": `style__tdName--AGnOB`,
	"thSim": `style__thSim--UiopJ`,
	"tdSim": `style__tdSim--IedDf`,
	"thWhitelisted": `style__thWhitelisted--ltCBT`,
	"tdWhitelisted": `style__tdWhitelisted--XC7TU`,
	"emptyState": `style__emptyState--H_ZvJ`
};
export default ___CSS_LOADER_EXPORT___;
